export type AuthorityGroupPolicy = {
    admin?: boolean,
    user?: boolean,
}
export type ShowReactionDateType = "owner" | "admin" | "user" | "all" | "";

export const CreateTopicAuthorityGroupPolicyDefault = { admin: true,  user: true };
export const UpdateTopicAuthorityGroupPolicyDefault = { admin: false };
export const ShowReactionDatePolicyDefault = false;
export const ShowReactionDateTypeDefault = "";
